export const mobileBP = 700;
export const desktopBP = 1024;
